import { render } from "./CardStat.vue?vue&type=template&id=3f6f47f2"
import script from "./CardStat.vue?vue&type=script&lang=js"
export * from "./CardStat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__